import { defineMessages } from "react-intl";
const messages = defineMessages({
    demoBannerText: {
        id: "app.aiDiscover.demo.banner.text",
        defaultMessage: "You're viewing a demo with sample data.",
    },
    demoBannerCta: {
        id: "app.aiDiscover.demo.banner.cta",
        defaultMessage: "Contact Sales for full access",
    },
});
export default messages;
